/* Theme-owned accessibility integration for dynamic storefront components. */
(() => {
  'use strict';
  const focusable = 'a[href],button,input:not([type="hidden"]),select,textarea,[tabindex]';
  const visible = el => el && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden' && getComputedStyle(el).display !== 'none';
  const tabs = root => [...root.querySelectorAll(focusable)].filter(el => visible(el) && !el.disabled && el.tabIndex >= 0 && !el.closest('[inert],[aria-hidden="true"]'));
  const status = document.getElementById('theme-accessibility-status');
  let activeDialog = null, returnFocus = null, lastTrigger = null, scheduled = false;
  const savedInert = new Map(), observed = new WeakSet(), ratingKeys = new WeakSet();
  const announce = text => { if (status) status.textContent = text; };
  const restoreBackground = () => { savedInert.forEach((value, el) => { el.inert = value; }); savedInert.clear(); };
  const excludeBackground = dialog => {
    let branch = dialog;
    while (branch && branch !== document.body) {
      [...branch.parentElement.children].forEach(el => {
        if (el === branch || el === status || /^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(el.tagName) || el.matches('.ds-cart-overlay,#PBarNextFrameWrapper')) return;
        savedInert.set(el, el.inert); el.inert = true;
      });
      branch = branch.parentElement;
    }
  };
  const firstFocus = dialog => (tabs(dialog)[0] || dialog).focus({preventScroll:true});
  function syncDialog() {
    const preferencesButton = document.querySelector('.pd-cp-ui-save');
    const preferences = preferencesButton?.closest('#pd-cp-preferences');
    const banner = document.querySelector('.cc-window:not(.cc-invisible)');
    const cart = document.querySelector('.ds-cart-drawer-inner.opened');
    const popup = document.querySelector('[data-kl-scroll-locking-modal="true"]');
    const menuRoot = document.querySelector('.drawer-menu');
    const menu = menuRoot?.classList.contains('visible') ? menuRoot.querySelector('.drawer-menu__panel') : null;
    const next = [preferences, banner, popup, cart, menu].find(visible) || null;
    if (next === activeDialog) return;
    const previous = activeDialog, oldReturn = returnFocus;
    restoreBackground(); activeDialog = next;
    if (next) {
      returnFocus = previous?.contains(lastTrigger) ? lastTrigger : (lastTrigger && !next.contains(lastTrigger) ? lastTrigger : document.activeElement);
      if (!returnFocus || returnFocus === document.body) returnFocus = oldReturn;
      next.setAttribute('role','dialog'); next.setAttribute('aria-modal','true');
      if (!next.hasAttribute('aria-label') && !next.hasAttribute('aria-labelledby')) next.setAttribute('aria-label',next === preferences ? 'Cookie-Einstellungen' : next === banner ? 'Cookie-Auswahl' : 'Menü');
      if (!next.hasAttribute('tabindex')) next.tabIndex = -1;
      next.inert = false;
      next.querySelectorAll('[tabindex]').forEach(el => { if (el.tabIndex > 0) el.tabIndex = 0; });
      excludeBackground(next); firstFocus(next);
    } else if (previous && oldReturn?.isConnected && visible(oldReturn) && !oldReturn.closest('[inert]')) {
      oldReturn.focus({preventScroll:true}); returnFocus = null;
    }
  }
  function watch(el) {
    if (!el || observed.has(el)) return;
    observed.add(el);
    new MutationObserver(schedule).observe(el,{attributes:true,attributeFilter:['class','style','aria-hidden']});
  }
  function normalize() {
    const menuRoot = document.querySelector('.drawer-menu');
    if (menuRoot) menuRoot.inert = !menuRoot.classList.contains('visible');
    document.querySelectorAll('.drawer-menu button.accordion').forEach(button => {
      const expanded = String(button.classList.contains('is-open'));
      if (button.getAttribute('aria-expanded') !== expanded) button.setAttribute('aria-expanded',expanded);
      const panel = button.nextElementSibling;
      if (panel?.classList.contains('accordion-content')) panel.inert = expanded !== 'true';
      watch(button);
    });
    document.querySelectorAll('.nav-children__wrapper').forEach(panel => {
      const open = panel.classList.contains('open'); panel.inert = !open;
      const trigger = document.querySelector('[data-parent][aria-controls="'+panel.id+'"]');
      if (trigger && trigger.getAttribute('aria-expanded') !== String(open)) trigger.setAttribute('aria-expanded',String(open));
      watch(panel);
    });
    document.querySelectorAll('.questions__accordion-answer').forEach(answer => {
      answer.inert = answer.getAttribute('aria-hidden') === 'true'; watch(answer);
    });
    document.querySelectorAll('button[data-button]').forEach(button => {
      const selected = String(button.classList.contains('selected'));
      if (button.getAttribute('aria-pressed') !== selected) button.setAttribute('aria-pressed',selected);
      watch(button);
    });
    document.querySelectorAll('.ruk_rating_snippet[aria-label]').forEach(el => {
      if (el.hasAttribute('tabindex') && !el.closest('a,button')) {
        el.setAttribute('role','button');
        if (!ratingKeys.has(el)) {
          ratingKeys.add(el);
          el.addEventListener('keydown',event=>{ if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); el.click(); } });
        }
      } else { el.setAttribute('role','img'); el.removeAttribute('tabindex'); }
    });
    document.querySelectorAll('button[role="combobox"][data-slot="select-trigger"]').forEach(button => {
      const label = button.parentElement.querySelector('label');
      if (label) {
        if (!label.id) label.id = 'theme-contact-label-' + (label.htmlFor || 'subject');
        button.setAttribute('aria-labelledby',label.id);
        if (!button.id && label.htmlFor) button.id = label.htmlFor;
      }
    });
    document.querySelectorAll('img[src*="68586161-1754-40a8-a79e-71a0454147a8"]').forEach(img => { if (!img.hasAttribute('alt')) img.alt = 'Duschbrocken'; });
    document.querySelectorAll('[role="button"][class*="Teaser-pointer-"]').forEach(button => {
      if (!button.textContent.trim() && !button.hasAttribute('aria-label')) button.setAttribute('aria-label','Newsletter-Angebot öffnen');
    });
    document.querySelectorAll('.custom-footer__klaviyo-form input:not([type="hidden"])').forEach(input => {
      input.style.setProperty('color','#353531','important');
      input.style.setProperty('background-color','#fff','important');
    });
    /* The legacy header leaves a second, empty cart link. It has no visible UI. */
    document.querySelectorAll('a[data-js-cart-icon]').forEach(el => {
      if (!el.textContent.trim() && !el.children.length) { el.removeAttribute('href'); el.tabIndex = -1; el.setAttribute('aria-hidden','true'); }
    });
    document.querySelectorAll('.drawer-menu,.ds-cart-drawer-inner,.cc-window,.pd-cp-ui-container').forEach(watch);
    document.querySelectorAll('[data-kl-scroll-locking-modal="true"]').forEach(watch);
    syncDialog();
    if (activeDialog && !activeDialog.contains(document.activeElement)) firstFocus(activeDialog);
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; normalize(); });
  }
  document.addEventListener('click', event => { lastTrigger = event.target.closest(focusable) || document.activeElement; schedule(); }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      if (activeDialog?.matches('.ds-cart-drawer-inner')) { event.preventDefault(); event.stopImmediatePropagation(); window.dispatchEvent(new CustomEvent('close-cart')); schedule(); }
      else if (activeDialog?.matches('.drawer-menu__panel')) { event.preventDefault(); event.stopImmediatePropagation(); activeDialog.querySelector('[data-drawer-close]')?.click(); schedule(); }
      else if (!activeDialog) { const open = document.querySelector('[data-parent][aria-expanded="true"]'); if (open) { event.preventDefault(); open.click(); open.focus(); } }
    }
    if (event.key !== 'Tab' || !activeDialog) return;
    const elements = tabs(activeDialog), first = elements[0], last = elements[elements.length-1];
    if (!first) { event.preventDefault(); activeDialog.focus(); }
    else if (event.shiftKey && (document.activeElement === first || !activeDialog.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || !activeDialog.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
  }, true);
  const cookieFocusStyles = new WeakMap();
  document.addEventListener('focusin', event => {
    if (activeDialog && !activeDialog.contains(event.target)) { event.stopImmediatePropagation(); firstFocus(activeDialog); return; }
    const el = event.target;
    if (el.closest('.cc-window,.pd-cp-ui-container') && el.matches(':focus-visible')) {
      const properties = ['outline','outline-offset','box-shadow','transition'];
      cookieFocusStyles.set(el,properties.map(name=>[name,el.style.getPropertyValue(name),el.style.getPropertyPriority(name)]));
      el.style.setProperty('outline','3px solid #193d4b','important');
      el.style.setProperty('outline-offset','3px','important');
      el.style.setProperty('box-shadow','0 0 0 3px #fff','important');
      el.style.setProperty('transition','none','important');
    }
  }, true);
  document.addEventListener('focusout', event => {
    const saved = cookieFocusStyles.get(event.target);
    if (saved) { saved.forEach(([name,value,priority])=>{ if (value) event.target.style.setProperty(name,value,priority); else event.target.style.removeProperty(name); }); cookieFocusStyles.delete(event.target); }
  },true);
  let previousCart = null;
  window.addEventListener('cart-initiated', event => { if (event.detail?.cart) previousCart = JSON.stringify(event.detail.cart.items.map(item=>[item.key,item.quantity])); });
  window.addEventListener('cart-update', event => {
    if (event.detail?.cart) {
      const cart = event.detail.cart, signature = JSON.stringify(cart.items.map(item=>[item.key,item.quantity]));
      if (signature !== previousCart) announce('Warenkorb aktualisiert. '+cart.item_count+' Artikel. Gesamtpreis '+new Intl.NumberFormat('de-DE',{style:'currency',currency:cart.currency || 'EUR'}).format(cart.total_price/100)+'.');
      previousCart = signature;
    }
    schedule();
  });
  ['open-cart','close-cart'].forEach(name => window.addEventListener(name,schedule));
  document.addEventListener('change', event => {
    if (event.target.matches('select[name^="options"]')) { const selected = [...event.target.selectedOptions].map(option=>option.textContent.trim()).join(', '); announce('Ausgewählt: '+selected+'.'); }
  });
  new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
  normalize();
})();
